import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Typography,
  alpha,
  styled
} from '@mui/material';
import {
  RocketLaunchTwoTone,
  InsertChartTwoTone,
  RestaurantTwoTone,
  Inventory2TwoTone,
  ReceiptLongTwoTone,
  TableRestaurantTwoTone,
  ManageAccountsTwoTone,
  CardMembershipTwoTone,
  LoyaltyTwoTone,
  LocalOfferTwoTone,
  NotificationsActiveTwoTone,
  EventNoteTwoTone,
  AccountBalanceWalletTwoTone,
  StorefrontTwoTone,
  DeliveryDiningTwoTone,
  ComputerTwoTone,
  MenuBookTwoTone,
  SvgIconComponent
} from '@mui/icons-material';
import { DocSection } from '@/constants/docs';

/** docs.ts içindeki `icon` string'ini MUI ikonuna eşler. */
const ICON_MAP: Record<string, SvgIconComponent> = {
  RocketLaunch: RocketLaunchTwoTone,
  InsertChart: InsertChartTwoTone,
  Restaurant: RestaurantTwoTone,
  Inventory2: Inventory2TwoTone,
  ReceiptLong: ReceiptLongTwoTone,
  TableRestaurant: TableRestaurantTwoTone,
  ManageAccounts: ManageAccountsTwoTone,
  CardMembership: CardMembershipTwoTone,
  Loyalty: LoyaltyTwoTone,
  LocalOffer: LocalOfferTwoTone,
  NotificationsActive: NotificationsActiveTwoTone,
  EventNote: EventNoteTwoTone,
  AccountBalanceWallet: AccountBalanceWalletTwoTone,
  Storefront: StorefrontTwoTone,
  DeliveryDining: DeliveryDiningTwoTone,
  Computer: ComputerTwoTone
};

const SectionSubheader = styled(ListSubheader)(
  ({ theme }) => `
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
    background: transparent;
    color: ${theme.colors.alpha.black[70]};
    font-weight: 700;
    text-transform: uppercase;
    font-size: ${theme.typography.pxToRem(11)};
    letter-spacing: 0.5px;
    line-height: 2.6;
  `
);

const ArticleButton = styled(ListItemButton)(
  ({ theme }) => `
    border-radius: ${theme.general.borderRadius};
    margin: 2px ${theme.spacing(1)};
    padding: ${theme.spacing(0.75, 1.5)};

    &.Mui-selected {
      background: ${alpha(theme.colors.primary.main, 0.12)};
      color: ${theme.colors.primary.main};
      &:hover { background: ${alpha(theme.colors.primary.main, 0.18)}; }
      & .MuiListItemText-primary { font-weight: 700; }
    }
  `
);

interface DocSidebarProps {
  sections: DocSection[];
  selectedId: string | null;
  onSelect: (articleId: string) => void;
  /** Aramayla eşleşen makale kimlikleri (varsa vurgulanabilir). */
}

function DocSidebar({ sections, selectedId, onSelect }: DocSidebarProps) {
  if (sections.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <MenuBookTwoTone sx={{ fontSize: 40, opacity: 0.4 }} />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Aramanızla eşleşen konu bulunamadı.
        </Typography>
      </Box>
    );
  }

  return (
    <List sx={{ pb: 2 }}>
      {sections.map((section) => {
        const Icon = ICON_MAP[section.icon] || MenuBookTwoTone;
        return (
          <li key={section.id}>
            <ul style={{ padding: 0, listStyle: 'none' }}>
              <SectionSubheader disableSticky>
                <Icon fontSize="small" />
                {section.title}
              </SectionSubheader>
              {section.articles.map((article) => (
                <ArticleButton
                  key={article.id}
                  selected={selectedId === article.id}
                  onClick={() => onSelect(article.id)}
                >
                  <ListItemIcon sx={{ minWidth: 0, mr: 1.5 }}>
                    <Box
                      sx={{
                        width: 6,
                        height: 6,
                        borderRadius: '50%',
                        bgcolor: 'currentColor',
                        opacity: 0.6
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={article.title}
                    primaryTypographyProps={{
                      variant: 'body2',
                      sx: { textTransform: 'none' }
                    }}
                  />
                </ArticleButton>
              ))}
            </ul>
          </li>
        );
      })}
    </List>
  );
}

export default DocSidebar;
